import { Form as AntForm } from "antd";
import { Tools } from "../utils";
import { useRef } from "react";

const useForm = () => {
  const focusedField = useRef();
  const [form] = AntForm.useForm();

  return {
    ...form,
    onFieldFocus: (name) => (focusedField.current = name),
    isFieldFocused: (name = "") => name === focusedField.current,
    getFieldsValue: ({ format = {} } = {}) => {
      const values = form.getFieldsValue();
      if (format?.name === "phone") {
        values[format.key] = Tools.formatPhone(values[format.key]);
      }
      return values;
    },
  };
};

export default useForm;
